import { motion } from "motion/react";
import { useState } from "react";
import styles from "./PuzzleChitGrid.module.css";
import {
  Heart,
  Star,
  Circle,
  Square,
  Sparkles,
  Zap,
  Crown,
  Gem,
  Flame,
  Music,
} from "lucide-react";

const puzzleIcons = [
  <Heart size={28} fill="white" />,
  <Star size={28} fill="white" />,
  <Circle size={28} />,
  <Square size={28} />,
  <Sparkles size={28} />,
  <Zap size={28} fill="white" />,
  <Crown size={28} fill="white" />,
  <Gem size={28} fill="white" />,
  <Flame size={28} fill="white" />,
  <Music size={28} />,
  <Heart size={28} fill="white" />,
  <Star size={28} fill="white" />,
  <Circle size={28} />,
  <Sparkles size={28} />,
  <Zap size={28} fill="white" />,
  <Crown size={28} fill="white" />,
];

export function PuzzleChitGrid() {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className={styles.grid}>
      {puzzleIcons.map((icon, index) => (
        <motion.div
          key={index}
          className={`${styles.chit} ${styles["color" + index]}`}
          initial={{ opacity: 0, scale: 0, rotate: -180 }}
          animate={{
            opacity: 1,
            scale: hoveredIndex === index ? 1.2 : 1,
            rotate: 0,
            y: hoveredIndex === index ? -10 : 0,
          }}
          transition={{
            delay: index * 0.05,
            type: "spring",
            stiffness: 300,
            damping: 20,
          }}
          whileHover={{
            scale: 1.2,
            rotate: [0, -10, 10, -10, 0],
            transition: { duration: 0.5 },
          }}
          whileTap={{ scale: 0.9 }}
          onHoverStart={() => setHoveredIndex(index)}
          onHoverEnd={() => setHoveredIndex(null)}
        >
          <motion.div
            animate={
              hoveredIndex === index
                ? { rotate: [0, 360], scale: [1, 1.2, 1] }
                : {}
            }
            transition={{ duration: 0.6 }}
          >
            {icon}
          </motion.div>
        </motion.div>
      ))}
    </div>
  );
}
